// duplexer allows narrow set of characters for resourceId, so we need to filter them out. Same is done in serverless comments-live-updates function
const DUPLEXER_SUPPORTED_CHARACTERS = '[^A-Za-z0-9_-]';
const regex = new RegExp(DUPLEXER_SUPPORTED_CHARACTERS, 'gu');
export const getDuplexerSafeValue = (value) => value.replace(regex, '');
//# sourceMappingURL=get-duplexer-safe-value.js.map